import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'
import AddIcon from '@material-ui/icons/Add'
import Hidden from '@material-ui/core/Hidden'
// import IconButton from '@material-ui/core/IconButton'
// import DeleteIcon from '@material-ui/icons/Delete'
import classNames from 'classnames'
import {
  listTemplates,
  deleteTemplate,
  receiveTemplate,
} from '../../actions/template'
import { REQUEST } from '../../utils/statusConstants'
// import GridList from '@material-ui/core/GridList'
// import GridListTile from '@material-ui/core/GridListTile'
// import GridListTileBar from '@material-ui/core/GridListTileBar'
import Templates from 'components/Templates'
// import HtmlImg from '../HtmlImg'
import language from 'utils/vast-languagepack'
import Icon from '@mdi/react'
import { mdiPlus } from '@mdi/js'
import { stepperIncrease } from 'actions/view'

const mapStateToProps = (state) => ({
  templatesById: state.email.templatesById,
  session: state.auth.session,
  templateLoadStatus: state.loadStatus.templatesById,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      listTemplates,
      deleteTemplate,
      receiveTemplate,
      stepperIncrease,
    },
    dispatch,
  )

const styles = (theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  tile: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
    borderRadius: '12px',
    '&:hover': {
      boxShadow: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
    },
  },
  gridListTile: {
    cursor: 'pointer',
  },
  paddingMobile: {
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing.unit * 3,
      width: '100vw',
    },
  },
})

class TemplatesPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      expanded: null,
      open: false,
    }
  }

  handleChange = (panel) => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    })
  }

  handleDeleteClick = (id) => {
    this.props.deleteTemplate(id)
  }

  handleTemplateClick = (id) => {
    this.props.receiveTemplate(this.props.templatesById[id])
  }

  handleCreateClick = () => {
    this.props.receiveTemplate('new')
    this.props.history.push('/templates/new')
  }

  render() {
    const {
      classes,
      templatesById,
      listTemplates,
      session,
      templateLoadStatus,
      history,
    } = this.props

    if (session) {
      if (templateLoadStatus === null) {
        listTemplates()
      }
    }

    const templates = (cols) => (
      <Templates
        cols={cols}
        handleTemplateClick={(template) => {
          receiveTemplate(template)
          this.props.stepperIncrease('template')
          this.props.stepperIncrease('task')
          return history.push(`/templates/${template.id}`)
        }}
      />
    )

    return (
      <div className={classes.paddingMobile}>
        {Object.keys(templatesById).length ? (
          <div>
            <Hidden only={['xs', 'sm', 'md']}>{templates(6)}</Hidden>
            <Hidden only={['xs', 'sm', 'lg', 'xl']}>{templates(4)}</Hidden>
            <Hidden only={['md', 'lg', 'xl']}>{templates(2)}</Hidden>
          </div>
        ) : templateLoadStatus === REQUEST || templateLoadStatus === null ? (
          <CircularProgress className={classes.progress} color='secondary' />
        ) : (
          <div
            style={{
              backgroundColor: '#ffffff',
              padding: '40px',
              border: 'solid 1px #adadad',
              borderRadius: '35px',
            }}
          >
            <div style={{ textAlign: 'center', fontSize: '20px' }}>
              {language.templatePage.templateFormPage.noResultsDisplay}
            </div>
            <div
              style={{
                textAlign: 'center',
                fontSize: '20px',
                backgroundColor: '#014c94',
                color: '#ffffff',
                padding: '1%',
                maxWidth: '300px',
                borderRadius: '20px',
                margin: '40px auto 0 auto',
                border: '1px solid black',
                cursor: 'pointer',
                boxShadow:
                  '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
              }}
              onClick={this.handleCreateClick}
            >
              <Icon path={mdiPlus} size={4} color='white' />
              <br />
              {language.templatePage.templateFormPage.createTemplate}
            </div>
          </div>
        )}
        <Tooltip
          title={language.templatePage.templateFormPage.createTemplate}
          placement='left'
        >
          <Button
            color='secondary'
            variant='fab'
            aria-label='Add'
            className={classNames(classes.button, classes.floatingActionButton)}
            onClick={this.handleCreateClick}
          >
            <AddIcon />
          </Button>
        </Tooltip>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(TemplatesPage))
